export default __webpack_public_path__ + "static/media/README.995e936f.md";